import React from 'react';
import { Box, Typography } from '@mui/material';

/**
 * QuickStatsBar — Displays today's operational metrics inline.
 */
const QuickStatsBar = ({ stats }) => {
  const items = stats
    ? [
        { icon: '📈', label: 'Trades today', value: stats.tradesExecuted },
        { icon: '🎯', label: 'Signals generated', value: stats.signalsGenerated },
        { icon: '🤖', label: 'AI overrides', value: stats.aiOverrides },
      ]
    : [
        { icon: '📈', label: 'Trades today', value: 0 },
        { icon: '🎯', label: 'Signals generated', value: 0 },
        { icon: '🤖', label: 'AI overrides', value: 0 },
      ];

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 3,
        px: 2.5,
        py: 1.5,
        backgroundColor: 'background.paper',
        border: 1,
        borderColor: 'divider',
        borderRadius: 2.5,
        flexWrap: 'wrap',
      }}
    >
      {items.map((item) => (
        <Box key={item.label} sx={{ display: 'flex', alignItems: 'center', gap: 0.8 }}>
          <Typography variant="body2" sx={{ fontSize: 14 }}>{item.icon}</Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary', fontSize: 13 }}>
            {item.label}:
          </Typography>
          <Typography variant="body2" sx={{ fontWeight: 700, fontSize: 13 }}>
            {item.value}
          </Typography>
        </Box>
      ))}
      {!stats && (
        <Typography variant="caption" sx={{ color: 'text.secondary', fontStyle: 'italic' }}>
          Data pending
        </Typography>
      )}
    </Box>
  );
};

export default QuickStatsBar;
